export const iconFontAwesomeMedicalHealthTooth = (
	<i className="fa-solid fa-tooth"></i>
);
